function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M37.769 41.601l19.969-19.969-19.97-19.969",
  stroke: "#333",
  strokeWidth: 3.033
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M.098 21.767h57.914",
  stroke: "#333",
  strokeWidth: 2.848
});

function SvgCalculatorIcon5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 43",
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNDMiIHZpZXdCb3g9IjAgMCA2MCA0MyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM3Ljc2ODYgNDEuNjAxM0w1Ny43Mzc3IDIxLjYzMjJMMzcuNzY4NiAxLjY2MzA2IiBzdHJva2U9IiMzMzMzMzMiIHN0cm9rZS13aWR0aD0iMy4wMzI3MSIvPgo8cGF0aCBkPSJNMC4wOTgxNDQ1IDIxLjc2NzVINTguMDEyMSIgc3Ryb2tlPSIjMzMzMzMzIiBzdHJva2Utd2lkdGg9IjIuODQ4MjMiLz4KPC9zdmc+Cg==";
export { SvgCalculatorIcon5 as ReactComponent };